<template>
  <FITFormCard>
    <div slot="header">
      <b-row align-v="center">
        <b-col cols=8>
          <p class="h5">{{$t('crm.Notification.list.header')}}</p>
        </b-col>
        <b-col cols="4" class="text-right">
        </b-col>
      </b-row>
    </div>
    <div slot="formBody">
      <b-alert variant="success" dismissible :show="shouldShowSuccessMessage">
        <span class="h5"><i class="fa fa-check-circle mr-2"></i>{{ $t('crm.lead.create.success') }}</span>
      </b-alert>
      <FITSearchableTable ref="notificationTable" :filters="filters" :actions="actions" :columns="columns" :keywordSearchDisabled='true' searchAction="getNotificationList" vuexModule="Crm" type="notification" @onRowSelected="onRowSelected">
<!--         <div slot="batchAction" slot-scope="batchActionCallback">
          {{batchActionCallback}}
        </div> -->
      </FITSearchableTable>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
import {
  FITPagination,
  FITFormCard,
  FITSelect,
  FITButton,
  FITTextInput,
  FITDatePicker,
  FITSearchableTable
} from '@/components';
import Vue from 'vue';
import Moment from 'moment';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'NotificationList',
  components: {
    FITPagination,
    FITFormCard,
    FITSelect,
    FITButton,
    FITTextInput,
    FITDatePicker,
    FITSearchableTable
  },
  data() {
    return {
      filters: [{
          label: this.$t('crm.Notification.list.category'),
          key: 'category',
          type: 'select',
          default: 'M', // Default All
          haveAll: false,
        },
        {
          label: this.$t('crm.Notification.list.notifiedStatus'),
          key: 'notified',
          type: 'select',
          default: null, // Default All
          options: [{ text: this.$t('crm.Notification.list.allNotification'), value: null },
            { text: this.$t('crm.Notification.list.unreadNotification'), value: "false" },
            { text: this.$t('crm.Notification.list.readNotification'), value: "true" },
          ],
        },
        {
          label: this.$t('crm.Notification.list.from'),
          key: 'startDate',
          type: 'datetime',
          default: '2016-01-01', // Default All
        },
        {
          label: this.$t('crm.Notification.list.to'),
          key: 'endDate',
          type: 'datetime',
          default: Moment().format('YYYY-MM-DD'), // Default All
        },
      ],
      actions: [],
      columnByCategory: {
        'M': [{
            key: 'notified',
            label: this.$t('crm.Notification.list.notifiedStatus'),
            thClass: 'text-center',
            tdClass: ['text-center', 'text-primary'],
            formatter: (row, key, item) => {
              return this.getTranslated(key, row);
            }
          },
          {
            key: 'messageType',
            label: this.$t('crm.Notification.list.messageType'),
            formatter: (row, key, item) => {
              return this.getTranslated(key, row);
            }
          },

          { key: 'content', label: this.$t('crm.Notification.list.content') },
          { key: 'createTime', label: this.$t('crm.Notification.list.createTime') },
        ],
        'B': [{
            key: 'englishName',
            label: this.$t('crm.Notification.list.englishName'),
            formatter: (row, key, item) => {
              return this.$options.filters.isEmpty(row);
            }
          },
          {
            key: 'chineseName',
            label: this.$t('crm.Notification.list.chineseName'),
            formatter: (row, key, item) => {
              return this.$options.filters.isEmpty(row);
            }
          },
          {
            key: 'content',
            label: this.$t('crm.Notification.list.content'),
            formatter: (row, key, item) => {
              return this.$options.filters.isEmpty(row);
            }
          },
          {
            key: 'comingBirthday',
            label: this.$t('crm.Notification.list.comingBirthday'),
            formatter: (row, key, item) => {
              return this.$options.filters.isEmpty(row);
            }
          },
        ],
        'R': [{
            key: 'policyNumber',
            label: this.$t('crm.Notification.list.policyNumber'),
            formatter: (row, key, item) => {
              return this.$options.filters.isEmpty(row);
            }
          },
          {
            key: 'policyType',
            label: this.$t('crm.Notification.list.policyType'),
            formatter: (row, key, item) => {
              return this.getTranslated(key, row);
            }
          },
          {
            key: 'customerName',
            label: this.$t('crm.customer.customerName'),
            formatter: (row, key, item) => {
              return this.$options.filters.isEmpty(item.englishNameCustomer) + "</br>" + this.$options.filters.isEmpty(item.chineseNameCustomer);
            }
          },
          { key: 'content', label: this.$t('crm.Notification.list.content') },
          { key: 'workFlowStep', label: this.$t('crm.Notification.list.workFlowStep') },
          { key: 'createTime', label: this.$t('crm.Notification.list.createTime') },


        ],
      },
      busy: false,
      timeout: null,
      shouldShowSuccessMessage: this.createSuccess
    }
  },

  props: {
    // createSuccess: {
    //   type: Boolean,
    //   default: false
    // }
  },

  computed: {
    ...mapState({
      'onChangeState': state => state.Crm.notificationList.onChangeState,
      'currentCategory': state => state.Crm.notificationList.category,

    }),
    columns() {
      return this.columnByCategory[this.currentCategory];
    },
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    ...mapGetters(['getTranslatedArray']),
  },

  watch: {
    onChangeState(newData, oldData) {
      // console.log(newData);
      if (newData == true) {
        let page = { page: 1, count: 25 };
        this.$refs.notificationTable.search(page);
        this.$store.commit('Crm/setNotificationOnChangeState', { state: false });
      }
    },
    currentCategory(newData, oldData) {
      if (newData != "M") {
        // Hide Notification Status
        this.filters[1].disabled = true;
      } else {
        this.filters[1].disabled = false;
      }
    },
    pagination: {
      deep: true,
      handler(val) {
        this.refreshPage();
      }
    },

    search: {
      handler(val) {
        if (this.busy) {
          return;
        }

        Vue.set(this, 'busy', true);
        if (timeout) {
          clearTimeout(this.timeout);
        }

        let timeout = setTimeout(() => {
          Vue.set(this, 'busy', false);
          Vue.set(this, 'timeout', null);
        }, 1500);

        var result = {};
        Object.keys(this.search).forEach((key) => {
          if (this.search[key] != null &&
            this.search[key].trim().length > 0) {
            result[key] = this.search[key];
          }
        });

        this.refreshPage(result);
      },
      deep: true // watch nested
    }
  },

  methods: {
    // onRowClicked(row) {
    //   console.log("row: "+row);
    // },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      if (type == 'notified') {
        if (key == '0') {
          return "●";
        } else {
          return "";
        }
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Crm', type)
        .filter((item) => {
          return item.value === key
        });
      if (type == 'category') {
        console.log(result);
      }
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    onRowSelected(item) {
      switch (this.currentCategory) {
        case "M":
          this.$router.push({
            name: 'Notification Router',
            params: {
              messageType: item.messageType,
              linkedEntityID: item.linkedEntityID,
              currentCategory: this.currentCategory
            }
          });
          break;
        case "R":
          this.$router.push({
            name: 'Notification Router',
            params: {           
              currentCategory: this.currentCategory,
              reminderDate: item.formattedNextPaymentDate,              
            }
          });
        break;
      }
      console.log(item);
    },
  },
  created() {
    // let filter = this.filters[0];
    // let options = [      
    // 'B','M','R'
    // ];
    // filter.options = [];
    // for (var i = 0; i < options.length; i++) {
    //   filter.options.push( {text:this.getTranslated('category', options[i]), value:options[i]});
    // }
  },
  mounted() {
    // if (this.createSuccess) {
    //   Vue.set(this, 'shouldShowSuccessMessage', true);
    //   setTimeout(() => {
    //     Vue.set(this, 'shouldShowSuccessMessage', false);
    //   }, 3000);
    // }
  }
}

</script>
<style>
.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Notification/NotificationList.vue